//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import accountDetails from '../pages/AccountDetails';
import personalData from '../pages/PersonalData';
import currencies from '../pages/Currency';
import legal from '../pages/LegalPages';
import download from '../pages/Download';


export default {
    name: 'DefaultLayout',
    components: {
        'account-details': accountDetails,
        'personal-data': personalData,
        'currencies': currencies,
        'legal': legal,
        'download': download,
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapState(['step']),
    },
    methods: {
    },
};
